import { render } from "./ClientCaptureManagement.vue?vue&type=template&id=e8e39b82&scoped=true"
import script from "./ClientCaptureManagement.vue?vue&type=script&lang=js"
export * from "./ClientCaptureManagement.vue?vue&type=script&lang=js"

import "./ClientCaptureManagement.vue?vue&type=style&index=0&id=e8e39b82&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8e39b82"]])

export default __exports__